"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const tailwind_1 = require("../utilities/tailwind.js");
function LayoutComponent({ children }) {
    return (0, jsx_runtime_1.jsx)("div", { className: "koa:min-h-screen koa:grid koa:grid-rows-[auto_1fr_auto]", children: children });
}
LayoutComponent.displayName = "Layout";
function Header({ children, fixed }) {
    return (0, jsx_runtime_1.jsx)("div", { className: ` ${fixed ? "koa:fixed koa:left-0 koa:w-full" : "koa:sticky"} koa:top-0 koa:z-50`, children: children });
}
Header.displayName = "Layout.Header";
function Content({ children, fullWidth }) {
    return (0, jsx_runtime_1.jsx)("main", { className: `${fullWidth ? "koa:w-full" : "koa:max-w-xl koa:w-full"} koa:mx-auto koa:p-2 koa:sm:p-4`, children: children });
}
Content.displayName = "Layout.Content";
function BottomNavigation({ children, className }) {
    return (0, jsx_runtime_1.jsx)("div", { className: (0, tailwind_1.twMerge)("koa:fixed koa:bottom-0 koa:left-0 koa:right-0 koa:pointer-events-none koa:z-20", className), children: children });
}
BottomNavigation.displayName = "Layout.BottomNavigation";
function Footer({ children }) {
    if (!children) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)("footer", { className: "koa:grid koa:justify-items-center koa:fixed koa:bottom-0 koa:left-0 koa:right-0 koa:z-5 koa:mt-2 koa:sm:mt-3 koa:lg:mt-4 koa:p-1", children: children });
}
Footer.displayName = "Layout.Footer";
function BottomSpacer({ className }) {
    return (0, jsx_runtime_1.jsx)("div", { className: className, "aria-hidden": "true" });
}
BottomSpacer.displayName = "Layout.BottomSpacer";
exports.Layout = Object.assign(LayoutComponent, {
    Header,
    Content,
    BottomNavigation,
    Footer,
    BottomSpacer,
});
